import React from 'react'
import {
  faCheckCircle,
  faTrash,
  faCog,
  faMinus,
  faExclamationTriangle
} from '@fortawesome/free-solid-svg-icons'
import ProcessStatusBadge from './process-status-badge'

const EXPORT_STATUS_CONFIG = {
  queued: { icon: faMinus, text: 'Queued', color: 'text-primary', spin: true },
  in_progress: { icon: faCog, text: 'In Progress', color: 'text-primary', spin: true },
  complete: { icon: faCheckCircle, text: 'Complete', color: 'text-success' },
  deleting: { icon: faTrash, text: 'Deleting', color: 'text-danger' },
  failed: { icon: faExclamationTriangle, text: 'Failed', color: 'text-danger' }
}

function ExportStatusBadge({ status }) {
  return <ProcessStatusBadge status={status} statusConfig={EXPORT_STATUS_CONFIG} />
}

export default ExportStatusBadge
